import {
    getAxios,
} from './axios'

import {addAuthTokenData} from './member';

export function getMemberPaymentHistory(params = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/payment_history/',
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberPaymentHistory.js